import * as React from 'react';

const SvgIconFirstCourse = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={25} height={24} fill="none" {...props}>
    <path
      clipRule="evenodd"
      d="M11.25 17.25l-3.2-3.334a1.891 1.891 0 01-.35-2.183v0a1.89 1.89 0 013.028-.49l.522.521.522-.522a1.89 1.89 0 013.028.491v0a1.89 1.89 0 01-.354 2.183L11.25 17.25z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.25 9v13.5M20.247 15H22.5a.75.75 0 00.75-.748c.008-3.831.028-8.458-1.56-12.289a.75.75 0 00-1.442.287V22.5M.75 1.5v6A1.5 1.5 0 002.25 9v0a1.5 1.5 0 001.5-1.5v-6M16.5 8.565a7.176 7.176 0 00-10.5 0M6 18.435a7.176 7.176 0 0010.5 0"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconFirstCourse;
